import { Component, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { AppService } from "../services/app.service";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from "@angular/common";
import { checkDate as checkDateUtil } from "../utils/format-util";

@Component({
  selector: "app-billing-reports",
  templateUrl: "./billing-reports.component.html",
})
export class BillingReportsComponent implements OnInit {
  today = new Date();
  historyList = [];
  monthList = [
    { text: "January", value: "01" },
    { text: "february", value: "02" },
    { text: "March", value: "03" },
    { text: "April", value: "04" },
    { text: "May", value: "05" },
    { text: "June", value: "06" },
    { text: "July", value: "07" },
    { text: "August", value: "08" },
    { text: "September", value: "09" },
    { text: "October", value: "10" },
    { text: "November", value: "11" },
    { text: "December", value: "12" },
  ];
  month: any = {};
  filterMonthName = "";
  errorMessage = "";
  feesType = "all";
  date1 = "";
  date2 = "";
  startDateFilter = "";
  endDateFilter = "";
  startDateObjPatient: any;
  offset = 0;
  formatter: any;
  public myDatePickerOptions1: IMyDpOptions = {};
  public myDatePickerOptions2: IMyDpOptions = {};

  constructor(
    private modalService: BsModalService,
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private datepipe: DatePipe
  ) {
    this.myDatePickerOptions1 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
    };

    this.myDatePickerOptions2 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
    };
  }

  tcCountryCode = "";
  ngOnInit() {
    this.tcCountryCode = localStorage.getItem("country_code");
    this.offset = +localStorage.getItem("offsetzone");
    this.getHistoryList("", "");
    this.formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });

    console.log(this.tcCountryCode);
    
  }

  convertutctolocal(value) {
    let flag;
    if (value) {
      const zoneDate = new Date(value);
      flag = this.datepipe.transform(
        zoneDate.setMinutes(zoneDate.getMinutes() + this.offset),
        "MMM dd, yyyy"
      );
    }
    return flag;
  }
  getMonthNameDiv(val: any) {
    const month = val.toString();
    this.monthList.forEach((obj) => {
      if (obj.value === month) {
        return obj.text;
      }
    });
  }

  getHistoryList(date1, date2) {
    let data;
    if (date1 && date2) {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        procedureId: "",
        startDate: date1,
        endDate: date2,
        tcId: localStorage.getItem("testCenterId"),
        feesType: this.feesType,
      };
    } else {
      data = {
        pageNumber: 0,
        pageRecord: 0,
        procedureId: "",
        startDate: "",
        endDate: "",
        tcId: localStorage.getItem("testCenterId"),
        feesType: this.feesType,
      };
    }

    this.appService.getBillingHistory(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"] && res["entity"].length > 0) {
            this.errorMessage = "";
            this.historyList = res["entity"];
          } else {
            this.historyList = [];
            this.errorMessage = "No record found";
            setTimeout(() => {
              this.errorMessage = "";
            }, 5000);
          }
        } else {
          this.historyList = [];
          this.errorMessage = "No record found";
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  onDateChanged1(event) {
    this.startDateFilter =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);
    // this.startDateObjPatient = event.date;

    const today = new Date(event.jsdate);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    this.startDateObjPatient = {
      day: this.checkDate(yesterday.getDate()),
      month: this.checkDate(yesterday.getMonth() + 1),
      year: yesterday.getFullYear(),
    };

    this.myDatePickerOptions2 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
      disableUntil: this.startDateObjPatient,
    };

    this.date2 = "";
    // this.endDatePatient = '';
  }

  onDateChanged2(event) {
    this.endDateFilter =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);
  }

  checkDate(str) {
    return checkDateUtil(str);
  }

  generateFilter() {
    if (this.startDateFilter || this.endDateFilter) {
      if (this.startDateFilter && this.endDateFilter) {
        this.getHistoryList(this.startDateFilter, this.endDateFilter);
      } else if (this.startDateFilter || this.endDateFilter) {
        this.errorMessage = "Please choose from and to date";
      }
    } else {
      this.getHistoryList("", "");
    }
  }

  refreshReport() {
    this.startDateFilter = "";
    this.endDateFilter = "";
    this.date1 = "";
    this.date2 = "";
    this.feesType = "all";
    this.getHistoryList("", "");
  }
}
